export function equalizeHeights() {
    const containers = document.querySelectorAll('[data-equalize-grid]');
    containers.forEach(container => {
        const [itemSelector, targetSelectors] = container.getAttribute('data-equalize').split(':');
        const itemContainerSelector = container.getAttribute('data-equalize-grid');
        // Find the closest grid container, either the current container or a parent
        const itemContainer = container.querySelector(itemContainerSelector) || container.closest(itemContainerSelector);
        if (!itemContainer)
            return;
        const items = itemSelector.startsWith('>')
            ? Array.from(itemContainer.children).filter(item => item.matches(itemSelector.slice(1).trim()))
            : Array.from(itemContainer.querySelectorAll(itemSelector));
        const columns = getComputedStyle(itemContainer).gridTemplateColumns.split(' ').length;
        const targets = targetSelectors.split(',').map(target => target.trim()).filter(Boolean);
        if (!items.length || !targets.length)
            return;
        for (let i = 0; i < items.length; i += columns) {
            const rowItems = items.slice(i, i + columns);
            targets.forEach(targetClass => {
                if (targetClass.startsWith('.')) {
                    let maxHeight = 0;
                    rowItems.forEach(item => {
                        const target = item.querySelector(targetClass);
                        if (target) {
                            maxHeight = Math.max(maxHeight, target.offsetHeight);
                        }
                    });
                    rowItems.forEach(item => {
                        const target = item.querySelector(targetClass);
                        if (target && maxHeight > target.offsetHeight) {
                            target.style.height = `${maxHeight}px`;
                        }
                    });
                }
            });
        }
    });
}
